import { Component, OnInit } from '@angular/core';
import { State } from '../../../../base/models/State';
import { ActivatedRoute, Router } from '@angular/router';
import { MeasurementStandardService } from '../../services/measurement-standard.service';
import { MeasurementStandard } from '../../models/measurement-standard';
import { stat } from 'fs';
import { EditForm } from '../../../../base/controlers/edit-form';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { FormGroup, FormControl } from '@angular/forms';
import { EnumOption } from '../../../../base/models/EnumOption';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-measurement-standard-edit',
  templateUrl: './measurement-standard-edit.component.html',
  styleUrls: ['./measurement-standard-edit.component.css']
})
export class MeasurementStandardEditComponent extends EditForm<MeasurementStandard> {


  constructor(
    ns: ToastrService,          
    tr:TranslateService,
    r: Router,
    ds:MeasurementStandardService,
    ar: ActivatedRoute,
    l:Location,    
  ) {     

    super(ns,tr,r,ds,ar,l,'/plasard-measurement/standard',[
      {
        id: '45e0f418-d1bc-4b6f-a7f1-17581a117fcd',
        code:'location',
        name: 'Prostor'
      },
      {
        id: '1548b97e-4b22-4b35-b947-649e3099430f',
        code:'layout',
        name: 'Postavitev'
      },
      {
        id: '80f18cde-7e22-4381-971e-de33bbde9394',
        code:'measurement',
        name: 'Izmere Prostora'
      },
      {
        id: '03bbc829-75f2-4aec-9773-5a51e3c21ec6',
        code:'sent',
        name: 'Poslano'
      }    
    ]);
  }
  layout2s:EnumOption[] = [
    {
      id:'766dc295-3658-4e4f-8eff-9428fc87a4a0',
      code:'str-str',
      name:'Stranica - Stranica'      
    },
    {
      id:'67e2e5fe-4507-4c21-b1eb-818a3eebc4e7',
      code:'zid-zid',
      name:'Zid - Zid'      
    },
    {
      id:'06cb6865-68b4-49b9-bd60-30940ff06ad0',
      code:'str-zid',
      name:'Stranica - Zid'      
    },
    {
      id:'6b8309ab-71e0-4173-b875-8e5ba9aee607',
      code:'zid-str',
      name:'Zid - Stranica'      
    }    
  ];
  floors:EnumOption[] = [
    {
      id:'07cf9c44-1772-4af8-b23d-2a25bc5f5def',
      name:'Keramika',
      code:'ceramic'
    },
    {
      id:'30f8e108-f883-4e67-84fb-290d49efbb53',
      name:'Tapison',
      code:'tapison'
    },
    {
      id:'6cf07a7f-c1de-4271-bc2b-7be7514e00a2',
      name:'Parket',
      code:'wood'
    }
  ];
  wallFloorLinings:EnumOption[] = [
    {
      id:'efb00dbd-c035-45be-ac69-e9d699dcf2e5',
      code:'yes',
      name:'Da'
    },
    {
      id:'791e0532-d333-4234-8b0c-0515ce5e7506',
      code:'no',
      name:'Ne'
    },
    {
      id:'5dfd2273-384e-408d-a77d-1ce65025e772',
      code:'partail',
      name:'Delno'
    }    
  ];
  responsibilitys:EnumOption[]=[
    {
      id:'793827b1-1c18-45ff-be35-4b0e9e7342a1',
      code:'carpenter',
      name:'Monter'
    },
    {
      id:'de0e28e3-00d4-4fce-9c5d-d3ebf4bc3969',
      code:'customer',
      name:'Stranka'
    }    
  ];

  ngOnInit() {
    this.form = new FormGroup({
      id: new FormControl(),
      code: new FormControl(),
      name: new FormControl(),
      stateId: new FormControl(),
      requestId: new FormControl(),
      requestCode: new FormControl({disabled:true}),
      customerName: new FormControl({disabled:true}),
      layoutId: new FormControl(),
      layout2Id: new FormControl(),
      intrixId: new FormControl(),
      floorId: new FormControl(),
      wallFloorLiningId: new FormControl(),
      wallFloorLiningHeight: new FormControl(),
      wallFloorLiningThickness: new FormControl(),
      onsitePicture1: new FormControl(),
      onsitePicture2: new FormControl(),
      onsitePicture3: new FormControl(),
      layout1: new FormControl(),
      layout2: new FormControl(),
      wallFloorLeft: new FormControl(),
      wallFloorRight: new FormControl(),
      wallFloorBack: new FormControl(),
      electric: new FormControl(),
      electricPrepareMoveId: new FormControl(),
      electricPrepareCutsId: new FormControl(),
      electricPreparAassemblyId: new FormControl(),
      additionalCuts: new FormControl(),
      additionalCutsLocationId: new FormControl(),
      signatureId: new FormControl(),
      intrixDocumentId: new FormControl()
    })    
    super.ngOnInit();
  }
  onSendToIntrix(){
  }
}
